export default "__VITE_ASSET__BDKC0gib__"